import { useTranslation } from 'react-i18next';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import { CARD_COLORS, colorHex, toneOf } from '../../views/cards/cardRules';
import { filterableFields } from '../advanced/advancedFilter';
import type { IColourRuleCardProps } from './IColourRuleCardProps';

/** Умови правил кольору (прототип v4 TV_OPS): дорівнює, не дорівнює, містить, порожнє, не порожнє, менше, більше. */
const OPS: readonly string[] = ['eq', 'neq', 'contains', 'empty', 'filled', 'lt', 'gt'];

/**
 * Правило кольору (прототип v4 L779-795): картка з тлом-попереднім переглядом кольору; «поле · умова · значення» (напр. «Високий» чи «today»),
 * «Тло» — 7 кольорів (вибраний з кільцем), ↑ (перемістити вгору) і × (вилучити).
 */
export function ColourRuleCard({ rt, rule, index, onChange, onUp, onRemove }: IColourRuleCardProps) {
  const { t } = useTranslation();
  const strings = useModuleStrings();
  const tone = toneOf(colorHex(rule.color));
  const noValue = rule.op === 'empty' || rule.op === 'filled';
  return (
    <div className="lv-vs__rule" style={{ background: tone.bg, borderColor: tone.bd }}>
      <div className="lv-vs__rule-row">
        <select className="lv-select" value={rule.field} aria-label={t('listbar.field')} onChange={(e) => onChange({ ...rule, field: e.target.value })}>
          {filterableFields(rt).map((f) => <option key={f.key} value={f.key}>{strings.field(rt.key, f.key, f.label)}</option>)}
        </select>
        <select className="lv-select" value={rule.op} aria-label={t('listbar.condition')} onChange={(e) => onChange({ ...rule, op: e.target.value })}>
          {OPS.map((op) => <option key={op} value={op}>{t(`listbar.ops.${op}`)}</option>)}
        </select>
        {!noValue && (
          <input className="lv-vs__rule-value" value={rule.value} placeholder={t('listViews.vs.ruleValue')} aria-label={t('listbar.value')}
            onChange={(e) => onChange({ ...rule, value: e.target.value })} />
        )}
      </div>
      <div className="lv-vs__rule-row">
        <span className="lv-vs__hint">{t('listViews.vs.background')}</span>
        {CARD_COLORS.map((c) => (
          <button key={c.key} type="button" className="lv-vs__swatch" title={t(`listViews.vs.colors.${c.key}`)} aria-label={t(`listViews.vs.colors.${c.key}`)}
            aria-pressed={colorHex(rule.color) === c.hex} style={{ background: c.hex, boxShadow: colorHex(rule.color) === c.hex ? `0 0 0 2px var(--surface), 0 0 0 4px ${c.hex}` : 'none' }}
            onClick={() => onChange({ ...rule, color: c.hex })} />
        ))}
        <span className="lv-vs__spacer" />
        <button type="button" className="lv-vs__move" disabled={index === 0} title={t('viewSettings.moveUp')} aria-label={t('listViews.vs.ruleUp')} onClick={onUp}>↑</button>
        <button type="button" className="lv-vs__move lv-vs__move--danger" title={t('listViews.vs.ruleRemove')} aria-label={t('listViews.vs.ruleRemove')} onClick={onRemove}>×</button>
      </div>
    </div>
  );
}
